<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">更多服务</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="minContent">
                <ul>
                    <li @click="showInfo">
                        <div class="card">
                            <img src="../../assets/images/puka.png" alt="">
                        </div>
                        <div v-if="isShow" class="cardInfo">
                            <div class="cardName">卡逸客普卡</div>
                            <div class="infoTitle">卡片信息</div>
                            <div>
                                <div class="infoItem">
                                    <img src="../../assets/images/zhekou.png" alt="">
                                    <span>消费享受</span>
                                    <div class="itemContent"><span>9折优惠</span></div>
                                </div>
                                <div class="infoItem">
                                    <img src="../../assets/images/jifen.png" alt="">
                                    <span>支持积分</span>
                                    <div class="itemContent"><span>消费1元得1积分</span></div>
                                </div>
                                <div class="infoItem">
                                    <img src="../../assets/images/chuxu.png" alt="">
                                    <span>支持储蓄</span>
                                </div>
                                <div class="infoItem">
                                    <img src="../../assets/images/huodong.png" alt="">
                                    <span>参与活动</span>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li @click="showInfo1">
                        <div class="card">
                            <img src="../../assets/images/yinka.png" alt="">
                        </div>
                        <div v-if="isShow1" class="cardInfo">
                            <div class="cardName">卡逸客普卡</div>
                            <div class="infoTitle">卡片信息</div>
                            <div>
                                <div class="infoItem">
                                    <img src="../../assets/images/zhekou.png" alt="">
                                    <span>消费享受</span>
                                    <div class="itemContent"><span>9折优惠</span></div>
                                </div>
                                <div class="infoItem">
                                    <img src="../../assets/images/jifen.png" alt="">
                                    <span>支持积分</span>
                                    <div class="itemContent"><span>消费1元得1积分</span></div>
                                </div>
                                <div class="infoItem">
                                    <img src="../../assets/images/chuxu.png" alt="">
                                    <span>支持储蓄</span>
                                </div>
                                <div class="infoItem">
                                    <img src="../../assets/images/huodong.png" alt="">
                                    <span>参与活动</span>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li @click="showInfo2">
                        <div class="card">
                            <img src="../../assets/images/jinka.png" alt="">
                        </div>
                        <div v-if="isShow2" class="cardInfo">
                            <div class="cardName">卡逸客普卡</div>
                            <div class="infoTitle">卡片信息</div>
                            <div>
                                <div class="infoItem">
                                    <img src="../../assets/images/zhekou.png" alt="">
                                    <span>消费享受</span>
                                    <div class="itemContent"><span>9折优惠</span></div>
                                </div>
                                <div class="infoItem">
                                    <img src="../../assets/images/jifen.png" alt="">
                                    <span>支持积分</span>
                                    <div class="itemContent"><span>消费1元得1积分</span></div>
                                </div>
                                <div class="infoItem">
                                    <img src="../../assets/images/chuxu.png" alt="">
                                    <span>支持储蓄</span>
                                </div>
                                <div class="infoItem">
                                    <img src="../../assets/images/huodong.png" alt="">
                                    <span>参与活动</span>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import { Navbar, TabItem } from 'mint-ui';
export default {
  data() {
    return {  
        isShow:false,
        isShow1:false,
        isShow2:false,
    };
  },
  computed: {},
  components: {},
  methods: {  
      showInfo(){
          if(this.isShow == true){
              this.isShow = false;
          }else{
              this.isShow = true;
              this.isShow1 = false;
              this.isShow2 = false;
          }
      },
      showInfo1(){
          if(this.isShow1 == true){
              this.isShow1 = false;
          }else{
              this.isShow1 = true;
              this.isShow = false;
              this.isShow2 = false;
          }
      },
      showInfo2(){
          if(this.isShow2 == true){
              this.isShow2 = false;
          }else{
              this.isShow2 = true;
              this.isShow = false;
              this.isShow1 = false;
          }
      },
  }           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
.card img{
    width: 9.87rem;
    height: 6.26rem;
}
.cardName{
    text-align: center;
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.7);
    line-height: 0.53rem;
}
.infoTitle{
    text-align: left;
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.5);    
    line-height: 0.53rem;
    width: 91%;
    margin-left: 0.26rem;
    padding-left: 0.32rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.1);
}
.infoItem{
    width: 25%;
    height: 2.34rem;
    margin-top: 0.26rem;
    text-align: center;
    float: left;
    position: relative;
}
.infoItem img{
    width: 0.87rem;
    height: 0.87rem;
    position: absolute;
    top: 0.24rem;
    left: 0.92rem;
}
.infoItem :nth-child(2){
    font-size: 0.37rem;
    position: absolute;
    top: 1.24rem;
    left: 0.65rem;
}
.itemContent{
    text-align: center;
    font-size: 0.26rem;
    margin-top: 1.8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/card/more.vue